<h3 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
  <span>{{ caption }}</span>
  <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
</h3>
<p>
  <span>{{ subcaption }}</span>
</p>

<div
  mat-dialog-actions
  fxLayout="row"
  fxLayoutAlign="end"
  style="padding-bottom: 20px"
>
  <button mat-raised-button color="warn" [mat-dialog-close]="true">
    {{ confirmButton }}
  </button>
  <button
    *ngIf="cancelButton"
    mat-stroked-button
    color="primary"
    [mat-dialog-close]="false"
  >
    {{ cancelButton }}
  </button>
</div>
